export default __webpack_public_path__ + "empty-issues-md.4a9d9f9f.svg";